'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftingRoute = undefined;

var _preventDirectServerAccess = require('helpers/preventDirectServerAccess');

var _preventDirectServerAccess2 = _interopRequireDefault(_preventDirectServerAccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var GiftingRoute = exports.GiftingRoute = function GiftingRoute() {
  return {
    path: '/gifts',

    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, { component: require('./Landing').Landing });
      }, 'gifts');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      var onEnter = (0, _preventDirectServerAccess2.default)('/gifts/purchase');

      require.ensure([], function (require) {
        callback(null, [{ path: 'purchase', component: require('./PurchaseContainer').PurchaseContainer }, { path: 'purchase/payment', component: require('./PaymentContainer').PaymentContainer, onEnter: onEnter }, { path: 'purchase/confirmation', component: require('./ConfirmationContainer').ConfirmationContainer, onEnter: onEnter }]);
      }, 'gifts');
    }
  };
};